import {isSingleCursor} from '../state.js';

export function canInsertTopLevelBlockSelectable({state}) {
  return selectionContainedInParagraph(state) && wholeLineWithOptionalNewline(state);
}

export function wholeLineWithOptionalNewline(state) {
  if (isSingleCursor(state)) {
    return cursorInEmptyLine(state);
  }
  return selectionSpansWholeLineOrLastLineBreak(state);
}

function selectionSpansWholeLineOrLastLineBreak(state) {
  const {from, to} = state.selection.main;
  const startLine = state.doc.lineAt(from);
  if (from === startLine.from || from === startLine.to) {
    const endLine = state.doc.lineAt(to);
    return to === endLine.to || to === endLine.from;
  }
  return false;
}

function cursorInEmptyLine(state) {
  const {from, to} = state.selection.main;
  const line = state.doc.lineAt(from);
  if (from === line.from && to === line.from) {
    return line.length === 0;
  }
  return false;
}

/**
 * Allows all kinds of wierd types inside the range,
 * as long as the ends of the range are clean.
 */
function selectionContainedInParagraph(state) {
  const {from, to} = state.selection.main;
  const left = state.tree.topNode.resolve(from, -1).type.name; // to the left of the start
  const right = state.tree.topNode.resolve(to, 1).type.name; // to the right of the end
  if (left === 'Paragraph' || left === 'Document') {
    return right === 'Paragraph' || right === 'Document';
  }
  return false;
}
